module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiVideoTopBar/asset/white-search.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiVideoTopBar/asset/white-search.png
// module id = 1719
// module chunks = 367